export const apiData = {
    "knownStrength": {
        "title": "Known Strengths",
        "tableValues": [
            {
                "category": "Team Effectiveness",
                "behavior": "behavior 1",
                "allButSelf": 8,
                "self": 8
            }
        ]
    },
    "unknownStrength": {
        "title": "Unknown Strengths",
        "tableValues": [
            {
                "category": "Team Effectiveness",
                "behavior": "behavior 1",
                "allButSelf": 8,
                "self": 8
            }
        ]
    },
    "knownImprovementAreas": {
        "title": "Known Improvement Areas",
        "tableValues": [
            {
                "category": "Team Effectiveness",
                "behavior": "behavior 1",
                "allButSelf": 8,
                "self": 8
            }
        ]
    },
    "unknownImprovementAreas": {
        "title": "Unknown Improvement Areas",
        "tableValues": [
            {
                "category": "Team Effectiveness",
                "behavior": "behavior 1",
                "allButSelf": 8,
                "self": 8
            }
        ]
    }
}

export const NO_DATA_MESSAGE = "No behavior meets the criteria."
export const MAPPING_ORDER = ["knownStrength", "unknownStrength", "knownImprovementAreas", "unknownImprovementAreas"]